import React, { useContext, useEffect, useRef, useState } from 'react'
import { MyContext } from '../../Context/MyProvider';
import { motion } from 'framer-motion';
import ImageLoad from '../ImageLoad';
import secureLocalStorage from 'react-secure-storage';
import Btn_loader from '../Btn_loader';
import ImagePrev from '../ImagePrev';
import PageLoading from '../PageLoading';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';
import { useTranslation } from 'react-i18next';
const RecentPost = () => {

    const { t } = useTranslation();
    const { BaseUrl, HandleCallApi, setIsToast, setToastMsg } = useContext(MyContext);

    const [loading, setLoading] = useState(true);
    const [page, setPage] = useState(1);
    const [postList, setPostList] = useState([]);
    const [showmore, setShowMore] = useState([]);
    const [iscommentmodel, setIsCommentModel] = useState(false);
    const [commentlist, setCoomentList] = useState([]);
    const [inputcomment, setInputComment] = useState("");
    const [commentdata, setCommentData] = useState("");
    const [deletecomid, setDeleteComId] = useState("");
    const [apiloading, setApiLoading] = useState("");
    const [imgList, setImgList] = useState("");
    const [imgIndex, setImgIndex] = useState(0);

    const postRef = useRef(false);
    const hasReachedBottom = useRef(false);
    const NoMoreDataRef = useRef(true);

    useEffect(() => {
        handleFetchData();
    }, [page]);

    useEffect(() => {
        const handleScroll = () => {
            const scrollTop = document.documentElement.scrollTop;
            const srollHight = document.documentElement.scrollHeight;
            const clientHight = window.innerHeight;

            const IsBottom = scrollTop + clientHight >= srollHight;
            if (IsBottom && !hasReachedBottom.current && NoMoreDataRef.current) {
                hasReachedBottom.current = true;
                postRef.current = false;
                setPage(page + 1);
            } else if (hasReachedBottom.current && !IsBottom) {
                hasReachedBottom.current = false;
            }
        }

        window.addEventListener("scroll", handleScroll);

        return () => {
            window.removeEventListener("scroll", handleScroll);
        }
    }, []);

    useEffect(() => {
        document.body.style.overflow = imgList ? "hidden" : "auto";
    }, [imgList]);

    const handleFetchData = async () => {
        if (postRef.current) return;
        postRef.current = true;
        const user_id = secureLocalStorage.getItem("Userid") || "0";
        const Response = await HandleCallApi("Post", "user/resent_posts", { page, user_id });
        const PostList = Response.data.post_list;

        if (PostList?.length == 0) {
            NoMoreDataRef.current = false;
            return;
        }

        if (page === 1) {
            setPostList(PostList);
        } else {
            setPostList([...postList, ...PostList]);
        }
        setLoading(false);
    }

    const handleShowMore = (id) => {
        if (showmore.includes(id)) {
            const FilterIds = showmore.filter((item) => item != id);
            setShowMore(FilterIds);
        } else {
            setShowMore([...showmore, id]);
        }
    }

    const handleLikePost = async (item) => {
        const Userid = secureLocalStorage.getItem("Userid");
        if (Userid) {
            const Response = await HandleCallApi("Post", "user/add_remove_like", { id: Userid, astrologer_id: item.astro_id, post_id: item.id });
            setIsToast(true);
            setToastMsg(Response.data.message);
            if (Response.data.ResponseCode === 200) {
                postRef.current = false;
                handleFetchData();
            }
        }
    }

    const handleGetComment = async (item, status) => {
        const Userid = secureLocalStorage.getItem("Userid");
        if (Userid) {
            setIsCommentModel(true);
            const ApiData = {
                id: Userid,
                astrologer_id: item.astro_id,
                post_id: item.id,
                comment: inputcomment || "",
                comment_id: deletecomid || "",
                status
            }
            setCommentData(item);

            if (status === "0") {
                setApiLoading("Comment");
            }

            if (status === "2") {
                setApiLoading("Delete");
            }

            const Response = await HandleCallApi("Post", "user/add_remove_comment_list", ApiData);
            if (Response && Response.data) {
                setCoomentList(Response.data.comment_list);
            }
            setApiLoading("");
            setInputComment("");
            setDeleteComId("");

        }
    }

    const handleSendComment = () => {

        if (!inputcomment) {
            setIsToast(true);
            setToastMsg("Please enter comment !!");
            return;
        }

        handleGetComment(commentdata, "1");
    }

    const handleKeyDown = (e) => {
        if (e.key === "Enter") {
            handleSendComment();
        }
    }

    return (
        <div className='recent_post_page'>

            {!loading && <div className="width_container">
                <div className="py-[15px] leading-4">
                    <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-2">{t("Recent Post")}</h1>
                    <p className="text-gray-800">{t("Manage your astrologers recent post")}</p>
                </div>

                <div className="mt-[20px]">
                    {postList.map((item, index) => {
                        const IsShow = showmore.includes(item.id);
                        return <motion.div key={index}
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            whileHover={{ y: -4 }}
                            transition={{ duration: 0.3 }}
                        >
                            <div key={index} className="w-full bg-white py-[20px] px-[25px] mt-[10px] shadow-md rounded-[15px]">

                                <div className="flex items-center gap-[10px]">
                                    <div className='w-16 h-16 overflow-hidden rounded-full'>
                                        <ImageLoad url={BaseUrl + item.pimage} CustomeStyle={"w-full h-full object-cover"} alt={"Astrologers img"} />
                                    </div>
                                    <div className="">
                                        <h1 className='font-medium text-[17px]'>{item.name}</h1>
                                        <span className='text-gray-700 text-[15px]'>{item.date} ago</span>
                                    </div>
                                </div>

                                {item?.text && <p className='text-gray-700 leading-5 text-[16px] mt-1'>
                                    {item?.text?.length > 600 ? (IsShow ? item.text : `${item.text.slice(0, 600)}...`) : item.text}
                                    {item?.text?.length > 600 && <button onClick={() => handleShowMore(item.id)} className='ms-[10px] text-blue-600 text-[15px] font-medium'>{IsShow ? t("Show Less") : t("Show More")}</button>}
                                </p>}

                                {item.media?.length >= 1 && <div className="slider-container mt-2">
                                    <Swiper
                                        slidesPerView={'auto'}
                                        spaceBetween={0}
                                        modules={[Pagination]}
                                        className="mySwiper"
                                    >
                                        {item.media.map((image, index) => {
                                            return <SwiperSlide key={index} onClick={() => { setImgList(item.media); setImgIndex(index) }} style={{ width: "150px", margin: "0 10px" }}>
                                                <ImageLoad url={BaseUrl + image} alt={`${item.name} Posted`} CustomeStyle={" w-[150px] h-[150px] object-cover rounded-[15px]"} />
                                            </SwiperSlide>
                                        })}
                                    </Swiper>
                                </div>}

                                {secureLocalStorage.getItem("Userid") && <div className="flex items-center gap-[10px] mt-[5px]">
                                    <button onClick={() => handleLikePost(item)} className="flex items-center gap-[5px] text-gray-700">
                                        {item.IsLike === 1
                                            ? <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M20.8299 11.465C19.6569 17.515 12 21 12 21C12 21 4.34292 17.515 3.16892 11.465C2.44892 7.75302 4.02197 4.01899 8.02097 3.99999C11 3.98599 12 6.98797 12 6.98797C12 6.98797 13 3.98499 15.978 3.99999C19.986 4.01899 21.5499 7.75402 20.8299 11.465Z" fill="red" />
                                            </svg>
                                            : <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M12 21.75C11.894 21.75 11.7879 21.728 11.6889 21.683C11.3619 21.534 3.66598 17.965 2.43198 11.609C1.95498 9.15 2.43398 6.75098 3.71298 5.19298C4.74798 3.93098 6.23594 3.25997 8.01694 3.25097C8.02594 3.25097 8.03494 3.25097 8.04294 3.25097C10.0749 3.25097 11.314 4.408 11.999 5.393C12.687 4.404 13.9359 3.24197 15.9809 3.25097C17.7629 3.25997 19.2519 3.93098 20.2879 5.19298C21.5649 6.74998 22.0429 9.14898 21.5649 11.61C20.3329 17.966 12.6359 21.536 12.3089 21.684C12.2119 21.728 12.106 21.75 12 21.75ZM8.04196 4.74999C8.03596 4.74999 8.03099 4.74999 8.02499 4.74999C6.68699 4.75599 5.62702 5.22497 4.87302 6.14397C3.87402 7.36097 3.513 9.29699 3.905 11.323C4.86 16.247 10.593 19.447 12 20.165C13.407 19.447 19.14 16.247 20.094 11.323C20.488 9.29599 20.127 7.35997 19.13 6.14397C18.376 5.22597 17.3159 4.75797 15.9749 4.75097C15.9689 4.75097 15.963 4.75097 15.958 4.75097C13.586 4.75097 12.745 7.12799 12.711 7.22899C12.607 7.53199 12.3209 7.73797 12.0009 7.73797C11.9989 7.73797 11.9979 7.73797 11.9969 7.73797C11.6759 7.73697 11.3899 7.53198 11.2879 7.22698C11.2549 7.12698 10.413 4.74999 8.04196 4.74999Z" fill="currentColor" />
                                            </svg>}
                                        <span className='font-medium text-[15px]'>{item.tlikes}</span>
                                    </button>
                                    <button onClick={() => handleGetComment(item, "0")} className="flex items-center gap-[5px] text-gray-700">
                                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M3.85693 21.75C3.71193 21.75 3.57111 21.748 3.43311 21.743C2.93311 21.731 2.49497 21.411 2.32397 20.928C2.15197 20.442 2.29408 19.9131 2.68408 19.5811C3.61608 18.8291 3.98892 17.997 4.13892 17.426C2.90192 15.947 2.24902 14.08 2.24902 12.001C2.24902 6.84798 6.25902 3.25 11.999 3.25C17.739 3.25 21.749 6.84898 21.749 12.001C21.749 17.153 17.739 20.752 11.999 20.752C10.812 20.752 9.67398 20.591 8.60498 20.2729C7.24198 21.4599 5.36393 21.75 3.85693 21.75ZM3.47803 20.243C3.48003 20.243 3.48189 20.243 3.48389 20.243C3.48089 20.244 3.47903 20.244 3.47803 20.243ZM12 4.75C7.143 4.75 3.75 7.73198 3.75 12.001C3.75 13.837 4.35498 15.463 5.50098 16.703C5.65598 16.871 5.72692 17.101 5.69092 17.328C5.52292 18.399 4.99511 19.412 4.18311 20.243C5.34311 20.201 6.90304 19.934 7.86304 18.91C8.06404 18.694 8.37503 18.617 8.65503 18.714C9.69003 19.072 10.815 19.2531 12 19.2531C16.857 19.2531 20.25 16.271 20.25 12.002C20.25 7.73295 16.857 4.75 12 4.75Z" fill="currentColor" />
                                        </svg>
                                        <span className='font-medium text-[15px]'>{item.tcomments}</span>
                                    </button>
                                </div>}
                            </div>
                        </motion.div>
                    })}
                </div>

            </div>}

            {iscommentmodel && <div onClick={() => setIsCommentModel(false)} className="model items-end">
                <div onClick={(e) => e.stopPropagation()} className="comment_box">

                    <div className="flex items-center gap-[10px]">
                        <button onClick={() => setIsCommentModel(false)}>
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M21.7501 12C21.7501 12.414 21.4141 12.75 21.0001 12.75H4.81115L10.5311 18.47C10.8241 18.763 10.8241 19.238 10.5311 19.531C10.3851 19.677 10.1931 19.751 10.0011 19.751C9.80909 19.751 9.61706 19.678 9.47106 19.531L2.47106 12.531C2.40206 12.462 2.3472 12.3791 2.3092 12.2871C2.2332 12.1041 2.2332 11.8971 2.3092 11.7141C2.3472 11.6221 2.40206 11.539 2.47106 11.47L9.47106 4.46999C9.76406 4.17699 10.2391 4.17699 10.5321 4.46999C10.8251 4.76299 10.8251 5.23803 10.5321 5.53103L4.81213 11.251H21.0001C21.4141 11.25 21.7501 11.586 21.7501 12Z" fill="black" />
                            </svg>
                        </button>
                        <h1 className='font-medium text-[18px]'>{t("Comment")}</h1>
                    </div>

                    {apiloading === "Comment"
                        ? <div className="h-full w-full flex items-center justify-center">
                            <Btn_loader CustomeStyle={"bg-[--bgcolor]"} />
                        </div>
                        : <div className="h-full scroll_container">
                            {commentlist.length >= 1
                                ? commentlist.map((item, index) => {
                                    return <div key={index} className={`px-[5px] py-[10px] ${index !== 0 && "border-t-[1px]"}`}>
                                        <div className="flex items-center justify-between">
                                            <div className="flex items-center gap-[20px]">
                                                <div className="w-[50px] h-[50px]">
                                                    <ImageLoad url={item.profile ? BaseUrl + item.profile : ""} alt={`${item.name} Profilepic`} CustomeStyle={"w-full h-full rounded-full object-cover"} />
                                                </div>
                                                <div className="leading-5">
                                                    <h1 className='font-medium text-[17px] text-gray-700'>{item.name}</h1>
                                                    <p className='text-[14px] text-gray-500'>{item.date} ago</p>
                                                </div>
                                            </div>
                                            {secureLocalStorage.getItem("Userid") == item.uid && <button onClick={() => setDeleteComId(item.id)} className='text-red-500'>
                                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M21 5.25H17.441C16.54 5.25 16.502 5.136 16.255 4.396L16.053 3.789C15.746 2.869 14.889 2.25 13.919 2.25H10.081C9.11099 2.25 8.253 2.868 7.947 3.789L7.745 4.396C7.498 5.137 7.46 5.25 6.559 5.25H3C2.586 5.25 2.25 5.586 2.25 6C2.25 6.414 2.586 6.75 3 6.75H4.298L5.065 18.249C5.213 20.474 6.57701 21.75 8.80701 21.75H15.194C17.423 21.75 18.787 20.474 18.936 18.249L19.703 6.75H21C21.414 6.75 21.75 6.414 21.75 6C21.75 5.586 21.414 5.25 21 5.25ZM9.37 4.263C9.473 3.956 9.75799 3.75 10.081 3.75H13.919C14.242 3.75 14.528 3.956 14.63 4.263L14.832 4.87C14.876 5.001 14.92 5.128 14.968 5.25H9.03C9.078 5.127 9.12301 5 9.16701 4.87L9.37 4.263ZM17.438 18.149C17.343 19.582 16.629 20.25 15.193 20.25H8.806C7.37 20.25 6.657 19.583 6.561 18.149L5.801 6.75H6.558C6.683 6.75 6.787 6.737 6.899 6.729C6.933 6.734 6.964 6.75 6.999 6.75H16.999C17.035 6.75 17.065 6.734 17.099 6.729C17.211 6.737 17.315 6.75 17.44 6.75H18.197L17.438 18.149ZM14.75 11V16C14.75 16.414 14.414 16.75 14 16.75C13.586 16.75 13.25 16.414 13.25 16V11C13.25 10.586 13.586 10.25 14 10.25C14.414 10.25 14.75 10.586 14.75 11ZM10.75 11V16C10.75 16.414 10.414 16.75 10 16.75C9.586 16.75 9.25 16.414 9.25 16V11C9.25 10.586 9.586 10.25 10 10.25C10.414 10.25 10.75 10.586 10.75 11Z" fill="currentColor" />
                                                </svg>
                                            </button>}
                                        </div>
                                        <p className='mt-[5px] text-[15px]'>{item.mes}</p>
                                    </div>
                                })
                                : <div className='h-full flex items-center justify-center'>
                                    <div className="text-center">
                                        <h1 className='font-medium text-[22px]'>{t("No comment yet")}</h1>
                                        <p className='text-[15px] text-gray-700'>{t("start the conversation")}</p>
                                    </div>
                                </div>}
                        </div>}
                    <div className="flex items-center gap-[10px] pt-[5px]">
                        <input type="text" value={inputcomment} onChange={(e) => setInputComment(e.target.value)} onKeyDown={handleKeyDown} placeholder={t('Poast your replay')} className='w-full border-[1px] focus-within:border-[--bgcolor] outline-none px-[10px] py-[8px] rounded-[10px]' />
                        <button onClick={handleSendComment} className='bg-[--bgcolor] rounded-full p-[10px]'>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M20.9271 3.07299C20.2251 2.37099 19.231 2.095 18.265 2.336L5.15221 5.61401C3.40421 6.05101 2.23808 7.55499 2.25108 9.35699C2.26408 11.159 3.45021 12.646 5.20421 13.059L9.85021 14.152L10.9432 18.797C11.3562 20.551 12.8431 21.737 14.6451 21.75C14.6541 21.75 14.6642 21.75 14.6732 21.75C16.4622 21.75 17.9521 20.587 18.3871 18.849L21.6651 5.73599C21.9051 4.77099 21.6301 3.77599 20.9271 3.07299ZM20.2091 5.37201L16.931 18.485C16.602 19.798 15.5412 20.258 14.6542 20.25C13.8092 20.244 12.7132 19.77 12.4032 18.454L11.2992 13.763L15.5301 9.531C15.8231 9.238 15.8231 8.763 15.5301 8.47C15.2371 8.177 14.7621 8.177 14.4691 8.47L10.2372 12.702L5.54601 11.598C4.22901 11.288 3.75513 10.191 3.74913 9.346C3.74313 8.50101 4.20202 7.397 5.51402 7.069L18.6271 3.79098C18.7341 3.76398 18.8421 3.751 18.9481 3.751C19.2881 3.751 19.6161 3.885 19.8651 4.134C20.1921 4.46 20.3211 4.92301 20.2091 5.37201Z" fill="white" />
                            </svg>
                        </button>
                    </div>
                </div>
            </div>}

            {deletecomid && <div onClick={() => setDeleteComId("")} className="model items-center">
                <div onClick={(e) => e.stopPropagation()} className="w-[300px] bg-white p-[20px] rounded-[15px]">
                    <h1 className='font-medium text-[20px]'>{t("Delete comment")}</h1>
                    <p className='leading-4 mt-[10px]'>{t("Are you sure you want to delete this comment?")}</p>
                    <div className="flex items-center gap-[10px] mt-[15px]">
                        <button onClick={() => setDeleteComId("")} className='w-full h-[40px] text-blue-500 font-medium border-[1px] border-blue-500 rounded-[10px]'>{t("Cancle")}</button>
                        <button onClick={() => handleGetComment(commentdata, "2")} className='w-full h-[40px] text-white bg-red-500 font-medium rounded-[10px]'>
                            {apiloading === "Delete"
                                ? <Btn_loader CustomeStyle={"bg-white"} />
                                : t("Delete")}
                        </button>
                    </div>
                </div>
            </div>}

            {imgList && <ImagePrev imgList={imgList} index={imgIndex} setImgList={setImgList} />}

            <PageLoading loading={loading} />
        </div>
    )
}

export default RecentPost